import React, { CSSProperties } from 'react';
import ClickableIcon from '../ClickableIcon/ClickableIcon';
import DynamicImage from '../DynamicImage/DynamicImage';
import DynamicImageIcon from '../DynamicImageIcon/DynamicImage';
import './SocialMedia.scss';

interface SocialMediaInterface {
  customClassName?: string;
  style?: CSSProperties;
}

const SocialMedia = ({ customClassName, style }: SocialMediaInterface) => {
  const className = 'social-media';

  return (
    <div className={className}>
      <div className={`${className}__container ${customClassName}`} style={style}>
        <ClickableIcon ariaLabel="explora instagram" isLink href="https://www.instagram.com/explorapodcasts">
          <DynamicImageIcon imageName="instagram" alt="instagram" />
        </ClickableIcon>
        <ClickableIcon ariaLabel="explora linkedin" isLink href="https://www.linkedin.com/company/explora-producciones/">
          <DynamicImageIcon imageName="linkedin" alt="linkedin" />
        </ClickableIcon>
        <ClickableIcon ariaLabel="explora facebook" isLink href="https://www.facebook.com/exploraproducciones/">
          <DynamicImageIcon imageName="facebook" alt="facebook" />
        </ClickableIcon>
        <ClickableIcon ariaLabel="explora youtube" isLink href="https://www.youtube.com/channel/UCKZyRjOAuS3YKZtfD4NT0NA">
          <DynamicImageIcon imageName="youtube" alt="youtube" />
        </ClickableIcon>
      </div>
    </div>
  );
};

export default SocialMedia;
